import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import ILogsFilters from '../../interfaces/ILogsFilters';
import { ILogsResult } from '../../interfaces/ILogsResult';

const useListForLogs = () => {
  const request = useRequest<ILogsResult>();
  const templateRequest = useRequest<{ ids: number[]; name: string }[]>();
  const path = 'medical-certificate/logs';

  const listForLogs = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filters: ILogsFilters,
  ): Promise<ILogsResult> => {
    return await request
      .post({
        path: `${path}?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
        sendAuthorization: true,
        body: { ...filters },
      })
      .then(result => result as ILogsResult)
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listTemplates = async (): Promise<{ ids: number[]; name: string }[]> => {
    return await templateRequest
      .getOne({
        path: `${path}/templates`,
        sendAuthorization: true,
      })
      .then(result => result as { ids: number[]; name: string }[])
      .catch(() => []);
  };

  return { listForLogs, listTemplates };
};

export { useListForLogs };